//messages.js
export default {
  home: 'Accueil'
}